import store from '@/store';
store.dispatch('initialize', { base_url: window.location.host });
